<template>
  <div class="salary-manage">
    <div class="hd ly-card">
      <el-select v-model="searchFormData.year" placeholder="学年">
        <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="searchFormData.term" placeholder="学期">
        <el-option v-for="item in terms" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select
        v-model="searchFormData.org_id"
        placeholder="部门"
        @change="getRootSp"
        @clear="search"
        filterable
        clearable
      >
        <el-option v-for="item in org_ids" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
      <el-select
        v-model="searchFormData.root_specialized_subject_id"
        placeholder="项目大类"
        :disabled="!searchFormData.org_id"
        @clear="search"
        @change="getSp"
        filterable
        clearable
      >
        <el-option v-for="item in root_specialized_subject_ids" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select
        @clear="search"
        @change="search"
        v-model="searchFormData.specialized_subject_id"
        placeholder="项目"
        filterable
        clearable
        :disabled="!searchFormData.org_id || !searchFormData.root_specialized_subject_id"
      >
        <el-option v-for="item in specialized_subject_ids" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="searchFormData.contract_type" clearable placeholder="合同类型">
        <el-option v-for="item in contract_types" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="searchFormData.contract_status" clearable placeholder="合同状态">
        <el-option
          v-for="item in contract_statues"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input v-model.trim="searchFormData.class_code" placeholder="班级代码"></el-input>
      <el-input v-model.trim="searchFormData.query" placeholder="教师姓名/证件号"></el-input>
      <el-button @click="search" class="m-t-10" type="primary">查询</el-button>
      <el-button @click="exportExcel">导出</el-button>
    </div>
    <div class="ly-card" v-loading="loading">
      <table class="native-table">
        <tr>
          <th colspan="10">总计</th>
          <th>{{ tableData.total.total_courses_count }}</th>
          <th>{{ tableData.total.total_class_count }}</th>
          <th>{{ tableData.total.total_origin_class_fee }}</th>
          <th>{{ tableData.total.total_actual_class_fee }}</th>
          <th>{{ tableData.total.total_term_fee }}</th>
          <th>{{ tableData.total.total_teacher_salary }}</th>
          <th>暂无</th>
          <th>暂无</th>
          <th>暂无</th>
        </tr>
        <tr>
          <th>教师姓名</th>
          <th>身份证</th>
          <th>银行卡号</th>
          <th>手机号</th>
          <th>部门</th>
          <th>项目大类</th>
          <th>项目</th>
          <th>班级名称</th>
          <th>班级代码</th>
          <th>课酬标准</th>
          <th>本学期课次</th>
          <th>实际人数</th>
          <th>学费应收</th>
          <th>学费实收</th>
          <th>本学期班课酬</th>
          <th>本学期总课酬</th>
          <th>实时课次</th>
          <th>实时学费</th>
          <th>实时课酬</th>
        </tr>
        <template v-for="item in tableData.list">
          <tr v-for="(curItem, index) in item.class_list" :key="`${item.teacher_id}/${curItem.class_id}`">
            <td v-if="index === 0" :rowspan="item.rowspan">
              {{ item.teacher_name }}
            </td>
            <td v-if="index === 0" :rowspan="item.rowspan">
              {{ item.id_card_no }}
            </td>
            <td v-if="index === 0" :rowspan="item.rowspan">
              {{ item.bank_card_no }}
            </td>
            <td v-if="index === 0" :rowspan="item.rowspan">
              {{ item.telephone }}
            </td>
            <td>{{ curItem.org_name }}</td>
            <td>{{ curItem.root_specialized_subject_name }}</td>
            <td>{{ curItem.specialized_subject_name }}</td>
            <td>{{ curItem.class_name }}</td>
            <td>{{ curItem.class_code }}</td>
            <td>{{ curItem.remuneration }}</td>
            <td>{{ curItem.courses_count }}</td>
            <td>{{ curItem.class_count }}</td>
            <td>{{ curItem.origin_class_fee }}</td>
            <td>{{ curItem.actual_class_fee }}</td>
            <td>{{ curItem.term_fee }}</td>
            <td v-if="index === 0" :rowspan="item.rowspan">{{ item.teacher_salary }}</td>
            <td>{{ curItem.course_student_count === -1 ? '-' : curItem.course_student_count }}</td>
            <td>{{ curItem.course_student_count === -1 ? '-' : curItem.real_course_student_count_fee }}</td>
            <td>{{ curItem.course_student_count === -1 ? '-' : curItem.real_term_fee }}</td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
import { Option, Input, Select } from 'element-ui';
import { finance, teacher } from '@/api';
import utils from '@/utils/utils';

const Decimal = require('decimal.js/decimal.js');

export default {
  name: 'SalaryManage',
  components: {
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option
  },
  data() {
    return {
      loading: true,
      searchFormData: {
        org_id: '',
        year: `${new Date().getFullYear()}`,
        term: '',
        specialized_subject_id: '',
        root_specialized_subject_id: '',
        contract_type: '',
        contract_status: 2,
        query: '',
        count_end_time: '2021-02-25 23:59:59',
        count_start_time: '2021-01-26 00:00:00',
        class_code: ''
      },
      tableData: {
        list: [],
        total: {}
      },
      years: [],
      terms: [],
      org_ids: [],
      root_specialized_subject_ids: [],
      specialized_subject_ids: [],
      contract_types: [],
      contract_statues: []
    };
  },
  mounted() {
    this.$store.dispatch('schoolYear/getTermAndYearList').then(data => {
      if (data) {
        this.years = data.year;
        this.terms = data.term;
        this.searchFormData.term = data.term[0].value;
        this.search();
      }
    });
    this.getOrg();
    teacher.contractStatus().then(res => {
      if (res) {
        this.contract_statues = res.data;
      }
    });
    teacher.contractType().then(res => {
      if (res) {
        this.contract_types = res.data;
      }
    });
  },
  filters: {
    percent(value) {
      return typeof value === 'number' ? `${Decimal.mul(value, 100).toNumber()} %` : '';
    }
  },
  methods: {
    reset() {
      this.misList = {}; // 总缺课key - value(总值)
      this.supList = {}; // 总代课key - value(总值)
      this.supListData = {}; // 总代课key - value(列表详情)
    },
    getOrg() {
      finance.orgQuery().then(res => {
        if (res) {
          this.org_ids = res.data.list;
        }
      });
    },
    changeOrg(row) {
      this.searchFormData.org_id = row.org_id;
      this.getRootSp();
    },
    getRootSp() {
      this.searchFormData.specialized_subject_id = '';
      this.searchFormData.root_specialized_subject_id = '';
      if (this.searchFormData.org_id) {
        finance.rootSpecializedSubjectQuery({ org_id: this.searchFormData.org_id }).then(res => {
          if (res) {
            this.root_specialized_subject_ids = res.data.list;
          }
        });
      } else {
        this.root_specialized_subject_ids = [];
      }
      this.search();
    },
    getSp() {
      this.searchFormData.specialized_subject_id = '';
      if (this.searchFormData.org_id && this.searchFormData.root_specialized_subject_id) {
        finance
          .specializedSubjectQuery({
            org_id: this.searchFormData.org_id,
            root_specialized_subject_id: this.searchFormData.root_specialized_subject_id
          })
          .then(res => {
            if (res) {
              this.specialized_subject_ids = res.data.list;
            }
          });
      } else {
        this.specialized_subject_ids = [];
      }
      this.search();
    },
    search() {
      this.reset();
      this.loading = true;
      finance
        .teacherSalaryDetail({
          params: this.searchFormData
        })
        .then(async res => {
          if (res && res.data) {
            this.tableData = res.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    pageChange({ page_size, page_no }) {
      this.paginConfig.page_no = page_no;
      this.paginConfig.page_size = page_size;
      this.search();
    },
    exportExcel() {
      const params = { ...this.searchFormData };
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null) delete params[key];
      });
      finance
        .exportTeacherSalary({
          params
        })
        .then(data => {
          if (data) utils.downloadData(data, '教师薪酬统计', 'xls');
        });
    }
  }
};
</script>

<style lang="less">
.salary-manage {
  .hd {
    overflow: hidden;
    .el-input,
    .el-select {
      width: 160px;
      margin-right: 20px;
    }
    .ly-search-comp {
      display: inline-block;
      margin: auto 5px;
    }
  }
  .base-inf {
    list-style: none;
    li {
      float: left;
      overflow: hidden;
      margin: 10px;
      > span {
        font-weight: 600;
        display: inline-block;
        width: 100px;
        margin-right: 10px;
      }
      > i {
        font-style: normal;
        display: inline-block;
        min-width: 200px;
      }
    }
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #fff;
  }
}
.create-salary {
  .input-short {
    width: 100px;
    padding: 10px;
  }
}
</style>
